import FileView from "./FileView";

export default FileView;
